jQuery(document).ready(function ($) {
    if ($('#studsvik_share').length) {

        $("#studsvik_share").ticker({
            dataUrl: 'https://vp254.alertir.com/afw/data/',
            language: 'sv',
            instrument: [{
                id: 'MDA:5547',
                name: 'SVIK'
            }],
            decimalPoints: 1,
            autoUpdate: 60,

            template: function (data) {

                function getDateDescription(d1, d2) {
                    if (d1.toDateString() === d2.toDateString()) {
                        return 'Today';
                    }

                    d1.setDate(d1.getDate() - 1);
                    if (d1.toDateString() === d2.toDateString()) {
                        return d2;
                    }

                    return moment.tz(d2, "Europe/Stockholm").format('YYYY-MM-DD');
                }

                function getTimeString(d) {
                    return moment.tz(d, "Europe/Stockholm").format('HH:mm');
                }

                function isNoDataTime(d) {
                    const dayOfWeek = d.getDay();
                    const time = getTimeString(d);

                    if (dayOfWeek === 0 || dayOfWeek === 6 || (dayOfWeek >= 1 && dayOfWeek <= 5 && time >= '00:00' && time < '09:00')) {
                        return true;
                    }

                    return false;
                }

                function getFormattedDateTime(data) {
                    const now = new Date();
                    const dataDate = new Date(data.value.date * 1000);
                    const lang = (typeof Weglot !== 'undefined') ? Weglot.getCurrentLang() : 'en';

                    if (data.isFallback || isNoDataTime(now)) {
                        if (lang === "sv") {
                            return 'Senaste';
                        } else {
                            return 'Latest';
                        }
                    } else {
                        return getDateDescription(now, dataDate) + ' ' + getTimeString(dataDate);
                    }
                }

                const isPositiveDiff = data.formatted.diff > 0;
                const pos = isPositiveDiff ? '+' : '';
                const last = data.formatted.last;
                const diff = data.formatted.diff;
                const diffpercent = data.value.diffpercent ? ` (${data.formatted.diffpercent}%)` : '';
                const formattedDateTime = getFormattedDateTime(data);

                let title = "The Studsvik Share";

                return `<div class="text-xs text-white flex font-semibold flex">${title} | ${formattedDateTime} | ` +
                    `<div class="stock-tick__img"></div>` +
                    ` ${data.formatted.last} SEK ` +
                    `${pos}${diff} SEK ${diffpercent}</div>`;

            }
        });
    }
});

function decodeHTML(text) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

<!-- end Simple Custom CSS and JS -->

//# sourceMappingURL=studsvik-share.js.map
